export default __webpack_public_path__ + "9b9983d.png";